


















import naja from 'naja';
import {Component, Prop, Vue} from 'vue-property-decorator';
import VueSlider from 'vue-slider-component';

@Component({components: {VueSlider}})
export default class SliderControl extends Vue {
    @Prop({type: Array, required: true})
    public readonly bounds: [number, number];

    @Prop({type: String, required: true})
    public readonly changeUrl: string;

    @Prop({type: Number, required: true})
    public readonly value: number;

    @Prop({type: Number, required: true})
    public readonly interval: number;

    @Prop({type: Boolean, default: false})
    public readonly percentage: boolean;

    @Prop({type: Boolean, default: true})
    public readonly showMinMaxValues: boolean;

    protected sliderValue: number = 1;

    protected lastSubmitValue: number = 1;

    protected formatter = '{value}';

    public created(): void {
        this.sliderValue = this.value;
        this.lastSubmitValue = this.value;
        this.formatter = this.percentage ? '{value}%' : '{value}';
    }

    private changeValue(value: number): void {
        this.sliderValue = value;
    }

    private submitChange(): void {
        if (this.lastSubmitValue === this.sliderValue) {
            return;
        }

        naja.makeRequest('POST', this.changeUrl, {value: JSON.stringify(this.sliderValue)})
            .then(() => this.lastSubmitValue = this.sliderValue);
    }
}
